import _ from "lodash";

const SYNC_DISABLE = "sync-disabled",
  SYNC_AUTO = "sync-auto",
  SYNC_MANUAL = "sync-manual";
//const SYNC_STATES_ARRAY = [SYNC_DISABLE, SYNC_AUTO, SYNC_MANUAL];
const SYNC_STATES = [SYNC_DISABLE, SYNC_AUTO, SYNC_MANUAL];
// const SYNC_STATES = {
//   "sync-disabled": 0,
//   "sync-auto": 1,
//   "sync-manual": 2,
// };

function getSyncStateText(syncState: string) {
  switch (syncState) {
    case SYNC_AUTO:
      return "[Auto]";
    case SYNC_MANUAL:
      return "[Manual]";
    case SYNC_DISABLE:
      return "[Disabled]";
    default:
      // must throw
      return "[Disabled]";
  }
}

const Synchronization = {
  getSyncStateText,
  SYNC_STATES,
  SYNC_DISABLE,
  SYNC_AUTO,
  SYNC_MANUAL,
};

export default Synchronization;
